const content = {
  content_about_us_developer: 'SignalStickerMaker.com（網頁）, Sigicker（iOS）, SignalSticker Maker（Android）皆由以下開發者開發：',
  content_about_us_ads: '此應用程式完全由開發者資助，包括伺服器托管、網絡、應用開發等成本。廣告是我們試圖涵蓋成本的唯一方法。我們已盡量減少廣告的影響。感謝您的理解！',
  faq_question_1: '我上傳的圖片會儲存在你們的資料庫中嗎？',
  faq_answer_1: '不會！貼圖包生成以後，所有圖片都會被刪除！',
  faq_question_2: '我可以修改貼圖包嗎？',
  faq_answer_2: '由於Signal的限制，您只能重新創建整個貼圖。',
  faq_question_3: '可以在貼圖包中指定表情符號和封面圖像嗎？',
  faq_answer_3: '我們正在努力中！請保持關注！',
};

const text = {
  text_about_us: '關於我們',
  text_developers: '開發者',
  text_advertisement: '廣告',
  text_image_selected: '已選圖片',
  text_image_selected_error: '請選擇至少1張圖片，最多30張圖片',
  text_maximum: '最多',
  text_supported_format: '支援格式',
  text_field_title: '標題',
  text_field_author: '作者',
  text_make_your_own_sticker: '製作你自己的Signal貼圖！',
  text_select_images: '選擇圖片',
  text_create_sticker: '創建貼圖',
  text_terms_and_conditions: '條款和細則',
  text_terms_and_conditions_2: '您在此聲明您已閱讀並同意',
  text_optional: '選填',
  text_download_now: '現在就下載！',
  text_compability: '兼容性',
  text_compability_android: 'Android 4.4+ 的Android設備',
  text_developed_by: '使用以下技術開發：',
  text_ssm_on_android: 'SignalStickerMaker 登錄 Android 啦！',
  text_android_trade_mark: '"Android", "Android Studio", "Google PlayStore" 及其商標皆為 Google LLC 所有。',
  text_ssm_on_ios: 'SignalStickerMaker 登錄 iOS 啦！',
  text_compability_ios_1: '配備 iOS 13+ 的 iPhone, iPad, iPod Touch',
  text_compability_ios_2: '配備 macOS 11.0+ 和 Apple M1晶片的Mac',
  text_ssm_trade_mark: 'Apple®, Mac®, Mac OS®, iPhone®, iPad®, iPod touch®, App Store®, Swift®, Xcode®，及其商標皆為 Apple Inc.在美國和其他國家的註冊商標。',
  text_faq: '常見問題',
  text_stats: '統計',
  text_statistics: '統計',
  text_total_sticker_packs: '在此創建的貼圖包總數',
  text_terms_privacy_condition: '條款、隱私和細則。',
  text_copy_right: '版權所有',
  text_give_app_a_try_question: '試試我們的App版本？',
  text_better_experience: '更好的體驗',
  text_store_your_sticker: '儲存您的貼圖',
  text_more_convenient: '更方便',
  text_no_thanks: '不，謝謝！',
  text_creating_sticker: '正在創建貼圖',
  text_close: '關閉',
  text_cancel: '取消',
  text_copy_to_clipboard: '複製到剪貼簿',
  text_copied: '已複製',
  text_add_sticker_now: '立即添加貼圖',
  text_try_again: '再試一次',
  text_report_to_us: '向我們回報',
  text_reported: '已回報',
  text_image_converting: '正在轉換圖片',
  text_sticker_created_successfully: '成功創建貼圖',
  text_service_busy: '服務忙碌',
  text_upload_failed_try_again: '上傳失敗，請再試一次',
  text_image_uploading: '正在上傳圖片',
  text_step_converting_image: '正在轉換圖片',
  text_step_uploading_image: '正在上傳圖片',
  text_step_result: '結果',
  text_educational_title: '在幾分鐘內創建專業Signal貼圖包',
  text_educational_description: '使用我們免費、易於使用的工具將您的圖像轉換為自定義Signal貼圖包。無論您是為朋友創建個人貼圖、商業品牌材料還是藝術表達，我們的平台都讓這個過程變得簡單而安全。無需技術技能！',
  text_quick_tips_title: '💡 更好貼圖的快速提示',
  text_tip_1: '使用高分辨率圖像（至少512x512像素）以獲得清晰的效果',
  text_tip_2: 'PNG格式最適合具有透明背景的圖像',
  text_tip_3: '保持設計簡單易識別，縮小時效果更好',
  text_tip_4: '每包創建10-30個貼圖以獲得最佳多樣性',
  text_about_signal_title: '關於Signal',
  text_about_signal_description: 'Signal是一個注重隱私的消息應用程序，支持自定義貼圖包。創建和分享您自己獨特的貼圖，讓您的對話更加個性化和有趣。',
  text_sticker_guide_card_title: '完整貼圖指南',
  text_sticker_guide_card_description: '學習創建專業Signal貼圖包的最佳實踐、設計原則和逐步說明。',
  text_image_formats_card_title: '圖像格式指南',
  text_image_formats_card_description: '了解PNG、WEBP、JPEG和GIF格式之間的差異，為您的貼圖選擇最佳選項。',
  text_learn_more: '了解更多',  
// --- Page Headers and Section Titles for ImageFormats and StickerGuide ---
image_formats_page_title: '自訂貼圖最佳圖像格式',
image_formats_page_description: '選擇最適合Signal貼圖包的圖像格式。了解PNG、WEBP、JPEG和GIF如何影響貼圖品質、檔案大小與相容性。',
image_formats_what_are_title: '如何選擇Signal貼圖格式',
image_formats_what_are_description: '您選擇的貼圖格式會影響貼圖在Signal中的顯示效果、載入速度與儲存空間。了解各種格式差異，創建最佳貼圖包。',
image_formats_comparison_title: '格式詳細比較',
image_formats_decision_matrix_title: '如何選擇貼圖格式',
image_formats_tech_specs_title: '技術規格比較',
image_formats_performance_title: '對Signal效能的影響',
image_formats_future_title: '貼圖格式的未來',
image_formats_conclusion_title: '準備好創建專屬Signal貼圖了嗎？',
image_formats_conclusion_description: '了解各種格式後，您可以根據需求選擇最適合的貼圖格式，讓Signal貼圖更美觀、載入更快。',

sticker_guide_page_title: 'Signal貼圖創建完整指南',
sticker_guide_page_description: '學習如何創建專業Signal貼圖包，掌握設計技巧、格式選擇與最佳實踐。',
sticker_guide_what_are_title: '什麼是Signal自訂貼圖？',
sticker_guide_what_are_description: '自訂Signal貼圖是您可以在Signal訊息中使用的個人化圖像，展現獨特風格與創意。',
sticker_guide_why_use_title: '為什麼要創建自訂貼圖？',
sticker_guide_why_use_description: '自訂貼圖讓訊息更有個性、更有趣，無論是個人、品牌或社群都適用。',
sticker_guide_best_practices_title: '貼圖設計最佳實踐',
sticker_guide_formats_title: '貼圖常用圖像格式',
sticker_guide_how_to_title: '如何製作Signal貼圖',
sticker_guide_advanced_tips_title: '進階貼圖創作技巧',
};

const language_spec = {
  lang_code: 'tw',
  name: '繁體中文',
  flag: '🇹🇼',
};

const menu_items = {
  menu_item_ios: 'iOS',
  menu_item_android: 'Android',
  menu_item_faq: '常見問題',
  menu_item_about_us: '關於我們',
  menu_item_support: '支援',
  menu_item_create_stickers: '創建貼圖',
  menu_item_sticker_guide: '貼圖指南',
  menu_item_image_formats: '圖像格式',
};

const seo = {
  seo_default_title: 'Signal Sticker Maker - 製作你自己的貼圖',
  seo_default_description: '免費Signal貼圖製作工具 - 在幾分鐘內為Signal訊息應用程式創建自定義貼圖。使用我們簡單易用的在線工具製作個性化貼圖包。無需安裝軟體，支持手機和電腦。',
  seo_support_title: '支援',
  seo_support_description: '聯繫我們以獲得支援',
  seo_ios_description: 'SignalStickerMaker.com 的 iOS APP 可在 App Store下載啦！',
  seo_android_description: 'SignalStickerMaker.com 的 Android APP 可在 Google Play Store下載啦！',
  seo_about_us_description: 'SignalStickerMaker.com 的故事',
  seo_faq_title: '常見問題',
  seo_faq_description: '瀏覽常見問題',
  seo_title_support: '支援',
  seo_title_support_description: '聯繫我們獲得支援和協助',
  canvas: '畫布',
  stickerCount: '貼圖數量',
  about_us_mission_title: '我們的使命',
  about_us_mission_content: '在 Signal Sticker Maker，我們相信溝通應該是個人化、有趣且具有創意的。我們的使命是讓貼圖創作民主化，讓任何人都能輕鬆地通過自定義Signal貼圖來表達自己。無論您是與朋友分享內部笑話、為企業建立品牌形象，還是只是想在對話中增加一些個性，我們都提供工具來實現 - 完全免費。',
  about_us_why_built_title: '為什麼我們要建立這個',
  about_us_why_built_content: 'Signal Sticker Maker的想法來自我們對於創建自定義貼圖選擇有限的沮喔。我們想要一個簡單、易於使用的工具，不需要技術專業知識或昂貴的軟體。以下是我們的動力：',
  about_us_accessibility: '可及性：無論技術技能如何，每個人都應該能夠創建自定義貼圖',
  about_us_privacy: '隱私：您的圖像會安全處理，永遠不會儲存在我們的伺服器上',
  about_us_simplicity: '簡單性：創建過程應該只需要幾分鐘，而不是幾個小時',
  about_us_quality: '品質：最終的貼圖應該是高品質且與Signal相容的',
  about_us_team_description: '我們的團隊結合了網頁開發、用戶體驗設計和移動應用程式的專業知識，創造出既強大又易於使用的工具。我們熱衷於開源技術，相信要建立尊重用戶隱私同時提供卓越功能的產品。',
  about_us_tech_stack_title: '我們的技術堆疊',
  about_us_tech_stack_description: '我們使用現代網頁技術構建Signal Sticker Maker，確保可靠性、速度和安全性：',
  about_us_frontend_title: '前端',
  about_us_frontend_description: '使用React.js和TypeScript打造響應式、類型安全的用戶介面',
  about_us_backend_title: '後端',
  about_us_backend_description: 'AWS Lambda無伺服器處理和S3安全檔案處理',
  about_us_security_title: '安全',
  about_us_security_description: '端到端加密和自動檔案刪除，確保最大隱私保護',
  about_us_privacy_security_title: '隱私和安全',
  about_us_privacy_security_description: '您的隱私是我們的首要考慮。以下是我們保護您資料的方法：',
  about_us_privacy_point_1: '盡可能在客戶端處理圖片',
  about_us_privacy_point_2: '上傳的檔案會在處理後自動刪除',
  about_us_privacy_point_3: '我們不會追蹤個人資訊或儲存用戶資料',
  about_us_privacy_point_4: '所有通訊都使用業界標準協議加密',
  about_us_community_title: '社區影響',
  about_us_community_description: '自推出以來，Signal Sticker Maker已經幫助數千名用戶創建自訂貼圖包。我們見到社區的驚人創意 - 從個人家庭貼圖到商業宣傳材料、教育資源和藝術表達。每個創建的貼圖包都代表著某人在數碼通訊中的獨特聲音。',
  about_us_ads_description: '營運免費服務需要可持續的資金。我們使用道德廣告做法，只與相關、高質素的廣告商合作。廣告收入幫助我們維護伺服器、開發新功能，並保持服務對所有人免費。我們承諾永遠不會為了廣告收入而犧牲用戶體驗或隱私。',
  about_us_future_title: '未來計劃',
  about_us_future_description: '我們不斷努力改善Signal Sticker Maker。以下是我們的計劃：',
  about_us_future_point_1: '用於微調貼圖的進階編輯工具',
  about_us_future_point_2: '批量處理以高效創建多個包',
  about_us_future_point_3: '快速貼圖創建的模板庫',
  about_us_future_point_4: '與其他訊息平台的整合',
  about_us_contact_title: '聯絡我們',
  about_us_contact_description: '我們喜歡聽到用戶的聲音！無論您有反饋、建議，或者只是想分享您的精彩貼圖創作，都不要猶豫聯絡我們。您的意見幫助我們為所有人建立更好的工具。',
  faq_intro: '歡迎來到我們的全面FAQ部分！在這裡您將找到關於創建自定義Signal貼圖、使用我們的signal貼圖製作器、圖像格式、設計最佳實踐和故障排除等最常見問題的答案。無論您是製作自定義貼圖的新手，還是希望完善您的訊息應用貼圖創作技能，這個指南都能幫助您。',
  faq_question_4: '支援哪些圖像格式？',
  faq_answer_4: '我們支援PNG、JPEG、WEBP和GIF格式。建議對於具有透明度的圖像使用PNG，對於照片使用JPEG，對於最佳檔案大小使用WEBP，對於簡單動畫使用GIF。每種格式根據您的使用情況都有其各自的優勢。',
  faq_question_5: '貼圖的建議圖像尺寸是多少？',
  faq_answer_5: '為了獲得最佳效果，請使用至少512x512像素的圖像。這確保您的貼圖在所有設備上都看起來清晰。建議的最大尺寸是1024x1024像素，以平衡品質和檔案大小。',
  faq_question_6: '一個貼圖包中可以包含多少個貼圖？',
  faq_answer_6: '您可以創建包含3到150個貼圖的貼圖包。我們建議從10-30個貼圖開始，這樣既有好的多樣性，又能保持管理的便利性。受歡迎的貼圖包通常有15-25個貼圖，涵蓋不同的情緒和情況。',
  faq_question_7: '我的圖像會儲存在您的伺服器上嗎？',
  faq_answer_7: '不會，我們優先考慮您的隱私。圖像會被暫時處理，在您的貼圖包創建完成後自動刪除。我們不會在我們的伺服器上儲存您的任何個人圖像或數據。',
  faq_question_8: '我可以創建動畫貼圖嗎？',
  faq_answer_8: '可以！您可以上傳GIF檔案來創建動畫貼圖。請記住，動畫貼圖應該簡單，不要太長，以確保在不同設備上都有良好的性能。',
  faq_question_9: '如何與其他人分享我的貼圖包？',
  faq_answer_9: '創建您的貼圖包後，您將收到一個Signal貼圖包連結。您可以直接與朋友分享這個連結、在社交媒體上發佈，或通過任何訊息應用發送。任何擁有連結的人都可以將您的貼圖添加到他們的Signal應用中。',
  faq_question_10: '如果我的貼圖在Signal中顯示不正確怎麼辦？',
  faq_answer_10: '如果您的貼圖顯得模糊或歪曲，請嘗試使用更高解析度的圖像（至少512x512像素）並確保它們是支援的格式。為了獲得最佳效果，對於具有透明度的圖形使用PNG格式，對於照片圖像使用JPEG。',
  faq_question_11: '我可以使用有版權的圖像嗎？',
  faq_answer_11: '您只應使用您擁有或有權使用的圖像。這包括您拍攝的照片、您創作的圖形，或具有適當許可證的圖像。未經許可使用受版權保護的材料可能違反版權法。',
  faq_question_12: '我可以創建的貼圖包數量有限制嗎？',
  faq_answer_12: '您可以創建的貼圖包數量沒有限制。盡情創建您想要的數量！每個貼圖包都是獨立的，可以擁有自己的主題、風格或目的。',
  faq_question_13: '創建後我可以編輯我的貼圖包嗎？',
  faq_answer_13: '一旦貼圖包被創建並上傳到Signal，就無法修改。但是，您可以創建一個帶有更改的新版本貼圖包，並分享新的連結。這是Signal處理貼圖包方式的限制。',
  faq_question_14: '為什麼我應該選擇PNG而不是JPEG來製作貼圖？',
  faq_answer_14: 'PNG對於貼圖來說是理想的，因為它支援透明度，讓您的貼圖能夠與任何聊天背景完美融合。PNG還提供無損壓縮，確保您的圖形保持清晰。只有在不需要透明度的照片類貼圖才使用JPEG。',
  faq_question_15: '什麼是好的貼圖設計？',
  faq_answer_15: '好的貼圖應該簡單、有表情、在縮小時也容易識別。使用鮮明的顏色、清晰的線條，避免過多細節。考慮您想要傳達的情緒或反應，並相應地進行設計。在整個貼圖包中保持風格一致性可以創造出統一的外觀。',
  faq_question_16: '我可以為商業用途創建貼圖嗎？',
  faq_answer_16: '當然可以！許多企業使用自定義貼圖進行行銷、客戶參與和品牌建設。您可以使用您的標誌、吉祥物或品牌角色創建貼圖。只要確保您有權使用任何品牌元素。',
  faq_question_17: '我需要特殊軟體來準備我的圖像嗎？',
  faq_answer_17: '不需要特殊軟體！您可以使用任何圖像編輯工具，從Photoshop等專業軟體到GIMP等免費替代品，甚至簡單的手機應用。關鍵是確保您的圖像符合尺寸和格式要求。',
  faq_question_18: 'WEBP與其他格式有什麼區別？',
  faq_answer_18: 'WEBP是Google開發的現代格式，在保持品質的同時提供優秀的壓縮。它通常比PNG小25-35%，同時支援透明度和動畫。但是，舊設備對WEBP的支援可能有限，所以PNG仍然是安全的通用選擇。',
  faq_still_questions_title: '還有問題嗎？',
  faq_still_questions_description: '如果您找不到您要找的答案，請不要猶豫聯繫我們的支援團隊。我們在這裡幫助您創建精彩的貼圖包！',
  faq_guides_description: '您也可以查看我們關於貼圖創建和圖像格式選擇的詳細指南，獲得更深入的資訊。',
};

const error = {
  error_file_size_title: '圖片超過最大檔案大小',
  error_file_size: '壓縮後的圖片檔案大小超過了10 MB。請在上傳前進一步限制您的圖片檔案大小。',
  error_conversion: '圖片轉換失敗。請嘗試使用其他瀏覽器和/或電腦。'
};

// Sticker Guide translations
const sticker_guide = {
  sticker_guide_page_title: 'Signal貼圖製作完整指南',
  sticker_guide_page_description: '通過我們的綜合指南學習如何創建專業的Signal貼圖包。了解最佳實踐、文件格式、設計技巧和逐步說明。',
  sticker_guide_what_are_title: '什麼是自定義Signal貼圖？',
  sticker_guide_what_are_description: '自定義Signal貼圖是您可以在Signal消息應用程序中創建和使用的個性化圖像。與標準表情符號不同，自定義貼圖允許您用獨特的圖像、藝術作品或照片表達自己，反映您的個性、內部笑話或品牌形象。我們的Signal貼圖製作器幫助您在幾分鐘內創建專業質量的貼圖包。',
  sticker_guide_why_use_title: '為什麼要為Signal創建自定義貼圖？',
  sticker_guide_why_use_description: '自定義貼圖通過為對話增加個性和創造力來改變您的消息體驗。無論是個人使用、商業品牌推廣還是社區建設，自定義消息應用貼圖都能幫助您比標準表情符號更有效、更難忘地進行交流。',
  sticker_guide_advantage_1: '個人表達：創建反映您個性、幽默或內部笑話的貼圖',
  sticker_guide_advantage_2: '品牌形象：企業可以創建品牌貼圖來吸引客戶',
  sticker_guide_advantage_3: '文化相關性：創建與您的文化背景或社區共鳴的貼圖',
  sticker_guide_advantage_4: '難忘的交流：用獨特的視覺元素在對話中脫穎而出',
  sticker_guide_best_practices_title: '貼圖創建最佳實踐',
  sticker_guide_best_practices_description: '要創建有效且引人入勝的貼圖，請遵循以下指導原則：',
  sticker_guide_image_quality_title: '圖像質量',
  sticker_guide_image_quality_1: '使用高分辨率圖像（至少512x512像素）',
  sticker_guide_image_quality_2: '確保清晰、銳利的細節在縮放時仍然可見',
  sticker_guide_image_quality_3: '避免過於複雜的設計，這些設計在變小時會變得不清楚',
  sticker_guide_design_principles_title: '設計原則',
  sticker_guide_design_principles_1: '保持設計簡單易識別',
  sticker_guide_design_principles_2: '使用對比色以獲得更好的可視性',
  sticker_guide_design_principles_3: '考慮每個貼圖的情感語境',
  sticker_guide_formats_title: '自定義貼圖的最佳圖像格式',
  sticker_guide_formats_description: '了解不同的圖像格式對於為Signal和其他消息應用創建最佳自定義貼圖至關重要：',
  sticker_guide_png_title: 'PNG',
  sticker_guide_png_best_for: '最適合：具有透明度的圖像',
  sticker_guide_png_advantages: '優點：無損壓縮，支持透明度',
  sticker_guide_png_file_size: '文件大小：較大但質量更高',
  sticker_guide_webp_title: 'WEBP',
  sticker_guide_webp_best_for: '最適合：現代網絡應用程序',
  sticker_guide_webp_advantages: '優點：較小的文件大小，良好的質量',
  sticker_guide_webp_file_size: '文件大小：比PNG小25-35%',
  sticker_guide_jpeg_title: 'JPEG',
  sticker_guide_jpeg_best_for: '最適合：攝影圖像',
  sticker_guide_jpeg_advantages: '優點：小文件大小，廣泛兼容性',
  sticker_guide_jpeg_limitations: '限制：不支持透明度',
  sticker_guide_gif_title: 'GIF',
  sticker_guide_gif_best_for: '最適合：動畫貼圖',
  sticker_guide_gif_advantages: '優點：動畫支持，透明度',
  sticker_guide_gif_limitations: '限制：有限的色彩調色板',
  sticker_guide_how_to_title: '如何製作自定義Signal貼圖：逐步指南',
  sticker_guide_how_to_description: '按照這個全面的指南，使用我們的免費貼圖製作器創建您自己的自定義Signal貼圖包：',
  sticker_guide_step_1: '規劃您的貼圖包：決定主題、風格和您想要表達的情感',
  sticker_guide_step_2: '準備您的圖像：創建或收集3-150張符合您主題的圖像',
  sticker_guide_step_3: '優化圖像：調整到適當的尺寸並優化文件大小',
  sticker_guide_step_4: '上傳到我們的Signal貼圖製作器：使用我們的免費在線工具將您的圖像編譯成Signal兼容的自定義貼圖包',
  sticker_guide_step_5: '測試您的包：將包添加到Signal並與朋友測試',
  sticker_guide_step_6: '分享和享受：與其他人分享您的包鏈接以傳播樂趣',
  sticker_guide_advanced_tips_title: '創作者的高級技巧',
  sticker_guide_advanced_tips_description: '使用這些專業技巧將您的貼圖創作提升到新的水平：',
  sticker_guide_consistency_title: '一致性是關鍵',
  sticker_guide_consistency_description: '在整個包中保持一致的藝術風格、色彩調色板和角色設計。這創造了用戶會認識和欣賞的一致視覺體驗。',
  sticker_guide_emotional_range_title: '情感範圍',
  sticker_guide_emotional_range_description: '包括涵蓋廣泛情感和情況的貼圖 - 快樂、悲傷、興奮、困惑、愛和幽默。這確保您的包在各種對話中都有用。',
  sticker_guide_test_others_title: '與他人測試',
  sticker_guide_test_others_description: '在最終確定您的包之前，與朋友和家人分享。獲得關於清晰度、情感影響和可用性的反饋。其他人可能會發現您錯過的問題。',
  sticker_guide_ready_title: '準備好創建您自己的貼圖了嗎？',
  sticker_guide_ready_description: '現在您了解了貼圖創建的基礎知識，您已準備好將您的想法變為現實！使用我們免費的Signal貼圖製作器將您的圖像轉換為專業的貼圖包，您可以與朋友、家人或整個Signal社區分享。',
};

// Image Formats translations  
const image_formats = {
  image_formats_page_title: 'Signal貼圖的最佳圖像格式',
  image_formats_page_description: '為您的Signal貼圖包選擇完美的圖像格式。了解PNG、WEBP、JPEG和GIF格式如何影響貼圖質量、文件大小和消息應用中的兼容性。',
  image_formats_what_are_title: '為Signal貼圖選擇正確的格式',
  image_formats_what_are_description: '您為Signal貼圖選擇的圖像格式直接影響它們在對話中的顯示方式、加載速度以及佔用的存儲空間。了解格式差異有助於您創建提供最佳用戶體驗的優化貼圖包。',
  image_formats_comparison_title: 'Signal貼圖格式比較',
  image_formats_future_title: '消息應用的未來格式',
  image_formats_future_description: '貼圖格式領域繼續與為消息應用優化的新技術一起發展：',
  
  // PNG Section - Sticker focused
  image_formats_png_title: 'PNG（Signal貼圖的完美選擇）',
  image_formats_png_description: 'PNG是Signal貼圖的黃金標準，提供完美的透明度支持和無損質量，保留您自定義設計的每個細節。',
  image_formats_png_features_title: '為什麼PNG最適合貼圖：',
  image_formats_png_feature_1: '無損壓縮 - 每個像素都保持完美',
  image_formats_png_feature_2: '完整透明度支持 - 適合貼圖裁剪',
  image_formats_png_feature_3: '在所有Signal版本中完美運作',
  image_formats_png_feature_4: '非常適合標誌、藝術作品和詳細插圖',
  image_formats_png_uses_title: '最佳Signal貼圖用途：',
  image_formats_png_use_1: '具有透明背景的角色貼圖',
  image_formats_png_use_2: '品牌標誌和商業貼圖',
  image_formats_png_use_3: '藝術插圖和繪畫',
  image_formats_png_use_4: '使用自定義字體的文字貼圖',
  image_formats_png_limitations_title: '考慮事項：',
  image_formats_png_limitations: '與壓縮格式相比文件較大，但質量權衡使PNG成為大多數Signal貼圖創作者的首選。',

  // WEBP Section - Sticker focused
  image_formats_webp_title: 'WEBP（現代貼圖優化）',
  image_formats_webp_description: 'WEBP為Signal貼圖提供質量和文件大小的最佳平衡，提供更快的加載時間同時保持優秀的視覺質量。',
  image_formats_webp_features_title: 'WEBP貼圖優勢：',
  image_formats_webp_feature_1: '比PNG小30-40%，質量相似',
  image_formats_webp_feature_2: '支持貼圖背景透明度',
  image_formats_webp_feature_3: '在現代Signal版本中快速加載',
  image_formats_webp_feature_4: '支持動態貼圖動畫',
  image_formats_webp_uses_title: '適合Signal貼圖包：',
  image_formats_webp_use_1: '節省空間的大型貼圖集合',
  image_formats_webp_use_2: '移動優化的貼圖包',
  image_formats_webp_use_3: '動畫反應貼圖',
  image_formats_webp_use_4: '快速加載的表情符號替代品',
  image_formats_webp_limitations_title: '考慮事項：',
  image_formats_webp_limitations: '雖然現代Signal客戶端完美支持WEBP，但PNG在所有設備和Signal版本中仍更具通用兼容性。',

  // JPEG Section - Sticker focused  
  image_formats_jpeg_title: 'JPEG（用於基於照片的貼圖）',
  image_formats_jpeg_description: 'JPEG適用於基於照片或不需要透明度的圖像的Signal貼圖，提供小文件大小以便更快分享。',
  image_formats_jpeg_features_title: 'JPEG照片貼圖優勢：',
  image_formats_jpeg_feature_1: '攝影內容的出色壓縮',
  image_formats_jpeg_feature_2: '快速分享的很小文件大小',
  image_formats_jpeg_feature_3: '所有設備的通用兼容性',
  image_formats_jpeg_feature_4: '非常適合迷因風格貼圖',
  image_formats_jpeg_uses_title: '最佳照片貼圖用途：',
  image_formats_jpeg_use_1: '來自照片的反應面部貼圖',
  image_formats_jpeg_use_2: '迷因風格矩形貼圖',
  image_formats_jpeg_use_3: '寵物照片貼圖',
  image_formats_jpeg_use_4: '風景或背景風格貼圖',
  image_formats_jpeg_limitations_title: '貼圖限制：',
  image_formats_jpeg_limitations: '不支持透明度限制創意可能性。JPEG最適合保留給矩形格式效果良好的基於照片的貼圖。',

  // GIF Section - Sticker focused
  image_formats_gif_title: 'GIF（用於動畫Signal貼圖）',
  image_formats_gif_description: 'GIF使動畫Signal貼圖為您的對話帶來運動和生命，非常適合反應和動態表達。',
  image_formats_gif_features_title: 'GIF動畫優勢：',
  image_formats_gif_feature_1: '內置動畫支持',
  image_formats_gif_feature_2: '在所有Signal版本中工作',
  image_formats_gif_feature_3: '非常適合反應貼圖',
  image_formats_gif_feature_4: '通用消息應用兼容性',
  image_formats_gif_uses_title: '完美動畫貼圖用途：',
  image_formats_gif_use_1: '反應GIF和情感貼圖',
  image_formats_gif_use_2: '簡單動畫角色',
  image_formats_gif_use_3: '加載或進度指示器',
  image_formats_gif_use_4: '慶祝和節日貼圖',
  image_formats_gif_limitations_title: '動畫考慮事項：',
  image_formats_gif_limitations: '限制為256種顏色，可能影響質量。複雜動畫的文件大小可能變大，影響消息加載速度。',

  // Decision Matrix Section - Sticker focused
  image_formats_decision_matrix_title: '為您的Signal貼圖選擇完美格式',
  image_formats_decision_guide: '快速貼圖格式決策指南：',
  image_formats_transparency_title: '需要透明度？',
  image_formats_transparency_best: '最佳：PNG、WEBP',
  image_formats_transparency_avoid: '避免：JPEG',
  image_formats_photography_title: '基於照片的貼圖？',
  image_formats_photography_best: '最佳：JPEG、WEBP',
  image_formats_photography_avoid: '考慮：PNG用於透明度',
  image_formats_animation_title: '想要動畫？',
  image_formats_animation_best: '最佳：GIF、WEBP',
  image_formats_animation_avoid: '靜態：PNG、JPEG',
  image_formats_filesize_title: '最小化文件大小？',
  image_formats_filesize_best: '最佳：WEBP、JPEG',
  image_formats_filesize_largest: '最大：PNG',

  // Technical Specifications - Sticker focused
  image_formats_tech_specs_title: 'Signal貼圖格式規範',
  image_formats_tech_feature: '特性',
  image_formats_tech_compression: '壓縮',
  image_formats_tech_transparency: '透明度',
  image_formats_tech_animation: '動畫',
  image_formats_tech_colors: '顏色支持',
  image_formats_tech_browser: 'Signal支持',
  image_formats_tech_lossless: '無損',
  image_formats_tech_both: '兩者',
  image_formats_tech_lossy: '有損',
  image_formats_tech_alpha: '完整Alpha',
  image_formats_tech_no: '否',
  image_formats_tech_binary: '基本',
  image_formats_tech_yes: '是',
  image_formats_tech_colors_full: '1670萬色',
  image_formats_tech_colors_limited: '256色',
  image_formats_tech_universal: '通用',
  image_formats_tech_modern: '現代',

  // Performance Section - Sticker focused
  image_formats_performance_title: '對Signal性能和用戶體驗的影響',
  image_formats_performance_description: '您選擇的貼圖格式直接影響貼圖在Signal對話中的加載速度以及消耗的數據量：',
  image_formats_loading_title: '消息加載速度',
  image_formats_loading_description: '較小的貼圖文件（WEBP、優化的JPEG）在對話中瞬間加載，創造流暢的聊天體驗。大型PNG文件可能導致延遲，特別是在較慢的連接上。',
  image_formats_mobile_title: '移動數據使用',
  image_formats_mobile_description: 'WEBP等高效格式在分享貼圖包時顯著減少數據消耗，使有限移動套餐的用戶更容易訪問。',
  image_formats_seo_title: '貼圖包分享',
  image_formats_seo_description: '優化的貼圖格式導致更快的貼圖包下載和安裝，鼓勵更多人添加和使用您的自定義貼圖。',

  // Future Section - Sticker focused
  image_formats_future_avif: 'AVIF：為未來消息應用提供卓越壓縮的下一代格式',
  image_formats_future_heif: 'HEIF：Apple的首選格式，在iOS消息中獲得關注',
  image_formats_future_svg: 'SVG：在任何設備屏幕上完美縮放的向量貼圖',

  // Conclusion - Sticker focused
  image_formats_conclusion_title: '準備好創建令人驚嘆的Signal貼圖了嗎？',
  image_formats_conclusion_description: '現在您了解了不同格式如何影響您的Signal貼圖，您可以做出平衡質量、文件大小和功能的明智選擇。無論您是使用PNG創建透明角色貼圖、使用WEBP優化文件大小，還是使用GIF添加動畫，正確的格式確保您的貼圖在每個Signal對話中都看起來很棒並表現良好。',
};

const translation = {
  ...language_spec,
  ...content,
  ...text,
  ...menu_items,
  ...seo,
  ...error,
  ...sticker_guide,
  ...image_formats,
};

export default translation;
